import { render, staticRenderFns } from "./company-modal.vue?vue&type=template&id=213d9a20&scoped=true"
import script from "./company-modal.vue?vue&type=script&lang=js"
export * from "./company-modal.vue?vue&type=script&lang=js"
import style0 from "./company-modal.vue?vue&type=style&index=0&id=213d9a20&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d9a20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213d9a20')) {
      api.createRecord('213d9a20', component.options)
    } else {
      api.reload('213d9a20', component.options)
    }
    module.hot.accept("./company-modal.vue?vue&type=template&id=213d9a20&scoped=true", function () {
      api.rerender('213d9a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/company-management/company-modal.vue"
export default component.exports